export const PLAID_CONFIG = {
  clientName: 'Acorns',
  apiVersion: 'v2',
}

export const PLAID_LINK_LIBRARY_SOURCE_URI =
  'https://cdn.plaid.com/link/v2/stable/link-initialize.js'

export const PLAID_LINK_VALID_PRODUCTS = ['auth', 'transactions']
